import { render } from "./permissions-list.vue?vue&type=template&id=8780d8de&lang=pug"
import script from "./permissions-list.vue?vue&type=script&setup=true&lang=js"
export * from "./permissions-list.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__